export default function () {
  $(document).on('ready', function() {
    jQuery('.mega-menu').hover(function() {
      jQuery(this).toggleClass('is-hovered');
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/SetupHeaderNav.js